/* Estimates are provisional; the authenticated carrier callback verifies all prices. */
(function () {
  'use strict';
  var PROPERTY = '_inmotion_import_quote';
  var CLEARED = '_inmotion_import_quote_cleared';
  var ENDPOINT = 'https://dashboard.inmotionservicecenter.com/api/public/shopify/canada-import-quote';
  var CURRENCIES = ['USD', 'CAD'];
  var RATE_NOTE = ' Checkout can continue at the standard shipping rate.';
  // Ops stores item.price as unit_price_cents and matches original_price to the
  // list unit. discounted_price is the same paid unit the shopper actually pays.
  // Do not send discount_allocations, discounts, final_line_price, or line_price:
  // the carrier parser rejects those representations.
  function properties(item) {
    var result = Object.assign({}, item.properties || {});
    delete result[PROPERTY];
    delete result[CLEARED];
    return result;
  }
  function wholeCents(value) { return Number.isSafeInteger(value) && value >= 0; }
  function merchandiseLineCents(item) {
    if (wholeCents(item.original_line_price)) return item.original_line_price;
    if (wholeCents(item.original_price) && Number.isSafeInteger(item.quantity) && item.quantity > 0) return item.original_price * item.quantity;
    if (wholeCents(item.final_line_price)) return item.final_line_price;
    if (wholeCents(item.final_price) && Number.isSafeInteger(item.quantity) && item.quantity > 0) return item.final_price * item.quantity;
    return null;
  }
  function paidLineCents(item) {
    // The smallest candidate is the price after line and cart discounts.
    // final_line_price omits cart-level discounts; discounted_price includes them.
    var options = [];
    if (wholeCents(item.original_line_price) && wholeCents(item.total_discount) && item.original_line_price >= item.total_discount) {
      options.push(item.original_line_price - item.total_discount);
    }
    if (wholeCents(item.discounted_price) && Number.isSafeInteger(item.quantity) && item.quantity > 0) options.push(item.discounted_price * item.quantity);
    if (wholeCents(item.final_line_price)) options.push(item.final_line_price);
    if (wholeCents(item.final_price) && Number.isSafeInteger(item.quantity) && item.quantity > 0) options.push(item.final_price * item.quantity);
    if (!options.length) return null;
    return options.reduce(function (min, value) { return value < min ? value : min; });
  }
  function cartFacts(cart) {
    if (!cart || !CURRENCIES.includes(cart.currency) || !Array.isArray(cart.items) || !cart.items.length) {
      throw new Error('A non-empty cart in USD or CAD is required for a Canadian estimate.');
    }
    var rows = cart.items.map(function (item) {
      if (!Number.isSafeInteger(item.quantity) || item.quantity < 1) throw new Error('One or more items need a reviewed Canadian quote. Please contact us.' + RATE_NOTE);
      var merchandise = merchandiseLineCents(item), paid = paidLineCents(item);
      if (!wholeCents(merchandise) || !wholeCents(paid) || paid > merchandise) throw new Error('One or more items need a reviewed Canadian quote. Please contact us.' + RATE_NOTE);
      return {item: item, merchandise: merchandise, paid: paid};
    });
    var recorded = rows.reduce(function (sum, row) { return sum + row.merchandise - row.paid; }, 0);
    var stated = wholeCents(cart.total_discount) ? cart.total_discount : 0;
    var applications = (cart.cart_level_discount_applications || []).reduce(function (sum, app) {
      return sum + (app && wholeCents(app.total_allocated_amount) ? app.total_allocated_amount : 0);
    }, 0);
    var extra = Math.max(stated, applications) - recorded;
    if (extra < 0) extra = 0;
    if (extra > 0) {
      var weight = rows.reduce(function (sum, row) { return sum + row.merchandise; }, 0);
      if (weight <= 0 || extra > weight) throw new Error('The discounted price can\'t be quoted exactly. Checkout can continue without this estimate.');
      var shares = rows.map(function (row) { return Math.floor(extra * row.merchandise / weight); });
      var leftover = extra - shares.reduce(function (sum, share) { return sum + share; }, 0);
      rows.map(function (row, index) { return {index: index, remainder: (extra * row.merchandise) % weight}; })
        .sort(function (a, b) { return b.remainder - a.remainder || a.index - b.index; })
        .slice(0, leftover).forEach(function (ranked) { shares[ranked.index]++; });
      rows.forEach(function (row, index) { row.paid -= shares[index]; });
    }
    return rows.map(function (row) {
      var item = row.item;
      if (row.paid < 0 || row.paid % item.quantity !== 0) throw new Error('The discounted price can\'t be quoted exactly. Checkout can continue without this estimate.');
      var unit = row.paid / item.quantity;
      if (!Number.isSafeInteger(unit) || (item.requires_shipping && (!item.sku || !item.variant_id || unit <= 0))) {
        throw new Error('One or more items need a reviewed Canadian quote. Please contact us.' + RATE_NOTE);
      }
      return {sku: item.sku || '', variant_id: item.variant_id, quantity: item.quantity,
        price: unit, original_price: wholeCents(item.original_price) ? item.original_price : unit,
        discounted_price: unit, requires_shipping: item.requires_shipping,
        properties: properties(item), name: item.product_title || item.title || ''};
    });
  }
  function fingerprint(cart) {
    return JSON.stringify({currency: cart.currency, items: cartFacts(cart).map(function (item) {
      item.properties = Object.keys(item.properties).sort().map(function (key) { return [key, item.properties[key]]; });
      return JSON.stringify(item);
    }).sort()});
  }
  function cents(value) {
    if (typeof value !== 'string' || !/^(0|[1-9][0-9]*)\.[0-9]{2}$/.test(value)) throw new Error('The estimate is incomplete. Please try again.');
    var result = Number(value.replace('.', ''));
    if (!Number.isSafeInteger(result)) throw new Error('The estimate is incomplete. Please try again.');
    return result;
  }
  function validateQuote(quote, now, currency) {
    if (!quote || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(quote.quote_id || '') ||
        !CURRENCIES.includes(quote.currency) || (currency && quote.currency !== currency) ||
        quote.service_code !== 'ups_standard_ddp' || quote.is_estimate !== true ||
        !['ups_bundled', 'shopify_native'].includes(quote.tax_source) || !Number.isFinite(Date.parse(quote.expires_at)) ||
        Date.parse(quote.expires_at) <= now) throw new Error('The estimate is unavailable or expired. Please request a new estimate.');
    var c = quote.components || {}, i = quote.import_components || {}, x = quote.collection_components || {};
    ['transport', 'transport_markup', 'duties', 'taxes_and_fees', 'brokerage', 'import_charges', 'total'].forEach(function (key) { cents(c[key]); });
    [i, x].forEach(function (part) {
      if (cents(part.import_total) !== cents(part.duties) + cents(part.taxes_and_fees) + cents(part.brokerage)) throw new Error('The estimate totals disagree. Please try again.');
    });
    if (cents(c.total) <= 0 || cents(c.total) !== cents(c.transport) + cents(c.transport_markup) + cents(c.import_charges) ||
        c.import_charges !== x.import_total || c.duties !== x.duties || c.taxes_and_fees !== x.taxes_and_fees || c.brokerage !== x.brokerage ||
        (quote.tax_source === 'ups_bundled' && JSON.stringify([i.duties, i.taxes_and_fees, i.brokerage]) !== JSON.stringify([x.duties, x.taxes_and_fees, x.brokerage])) ||
        (quote.tax_source === 'shopify_native' && (cents(x.duties) !== 0 || cents(x.taxes_and_fees) !== 0 || i.brokerage !== x.brokerage))) {
      throw new Error('The estimate totals disagree. Please try again.');
    }
    return quote;
  }
  function tokenPath(value) {
    // Only a configured Shopify storefront app-proxy path may mint the token.
    // Never send it to an arbitrary URL or call the unsigned Ops token endpoint.
    if (typeof value !== 'string' || !/^\/(apps|a|community|tools)\/[A-Za-z0-9_-]+(?:\/[A-Za-z0-9_-]+)*$/.test(value)) {
      throw new Error('Canadian estimates are not available yet. Please contact us for a reviewed quote.' + RATE_NOTE);
    }
    return value;
  }
  function quoteToken(value) {
    if (!value || typeof value.token !== 'string' || !/^[0-9]{1,12}\.[0-9a-f]{64}$/.test(value.token) ||
        !Number.isInteger(value.expires_in) || value.expires_in < 1 || value.expires_in > 600) {
      throw new Error('The estimate is unavailable. Please try again or contact us for a reviewed quote.' + RATE_NOTE);
    }
    return value.token;
  }
  // Pure validation is also exercised by the no-network Node tests.
  if (typeof module !== 'undefined' && module.exports) module.exports = {cartFacts: cartFacts, fingerprint: fingerprint, validateQuote: validateQuote, tokenPath: tokenPath, quoteToken: quoteToken};
  if (typeof document === 'undefined') return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // The script is loaded only while the setting is on. A page without the
  // market attribute is the setting-off case; do not alter its checkout.
  if (!document.body.hasAttribute('data-canada-market')) return;
  var mounted = new WeakSet(), current = null, bypass = new WeakSet(), mutations = Promise.resolve(), departureClear = null, departureError = null, departureGeneration = 0, activeIntent = null, presence = 0, marketCode = null;
  function currentCountry() {
    var live = window.Shopify && window.Shopify.country;
    if (typeof live === 'string' && live) return live.toUpperCase();
    return (document.body.getAttribute('data-canada-market') || '').toUpperCase();
  }
  function canadaShopper() { return currentCountry() === 'CA'; }
  function active() {
    if (!canadaShopper()) return false;
    if (activeIntent !== null) return activeIntent;
    try {
      // A stored false is leftover state from another visit. It must not keep
      // Canada mode off once the shopper's country is Canada.
      if (sessionStorage.getItem('imscCanadaQuoteActive') === 'true') return true;
    } catch (_) { /* The market still selects Canada mode without storage. */ }
    return true;
  }
  function setActive(value) {
    presence++;
    activeIntent = value;
    document.body.classList.toggle('canada-import-active', !!value && canadaShopper());
    // Never persist false while the shopper is outside Canada. That value
    // would otherwise block the next switch into Canada.
    if (!canadaShopper()) return;
    try { sessionStorage.setItem('imscCanadaQuoteActive', String(value)); } catch (_) { /* Storage is optional. */ }
  }
  function clearStaleActive() {
    var token = presence;
    return function () { if (token === presence) setActive(false); };
  }
  function syncMarket() {
    var code = currentCountry();
    if (code && document.body.getAttribute('data-canada-market') !== code) document.body.setAttribute('data-canada-market', code);
    var ca = code === 'CA';
    document.body.classList.toggle('canada-import-enabled', ca);
    document.querySelectorAll('[data-canada-import-quote]').forEach(function (el) { el.hidden = !ca; });
    if (code === marketCode) return;
    var previous = marketCode;
    marketCode = code;
    departureError = null;
    if (previous === 'CA' && !ca) {
      departureClear = null;
      if (current && current.element && current.element.isConnected) {
        current.invalidate();
        var offToggle = current.element.querySelector('[data-canada-active]');
        var offPanel = current.element.querySelector('[data-canada-panel]');
        if (offToggle) offToggle.checked = false;
        if (offPanel) offPanel.hidden = true;
      }
      setActive(false);
      updateReferences(null, null, current).catch(function () {});
      return;
    }
    if (ca) {
      activeIntent = null;
      setActive(true);
      if (current && current.element && current.element.isConnected) {
        var onToggle = current.element.querySelector('[data-canada-active]');
        var onPanel = current.element.querySelector('[data-canada-panel]');
        if (onToggle) onToggle.checked = true;
        if (onPanel) onPanel.hidden = false;
      }
    }
  }
  function canadaEngaged() {
    if (!canadaShopper()) return false;
    if (active() || departureClear || departureError || document.body.classList.contains('canada-import-active')) return true;
    if (current && current.element && current.element.isConnected) {
      var toggle = current.element.querySelector('[data-canada-active]');
      if (toggle && toggle.checked) return true;
    }
    return false;
  }
  async function releaseQuote() {
    try {
      if (current && current.element && current.element.isConnected) {
        current.invalidate();
        await updateReferences(null, null, current);
      } else await updateReferences(null);
    } catch (_) { /* A failed clear must not block checkout. */ }
    setActive(false);
    departureClear = null;
    departureError = null;
  }
  function continueCheckout(form, button) {
    bypass.add(form);
    if (button) button.disabled = false;
    if (typeof form.requestSubmit === 'function') {
      if (button) form.requestSubmit(button); else form.requestSubmit();
    } else form.submit();
  }
  async function json(url, data, token) {
    var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 20000);
    try {
      var headers = data ? {'Content-Type': 'application/json'} : {};
      if (url === ENDPOINT && token) headers['X-InMotion-Quote-Token'] = token;
      var response = await fetch(url, {method: data ? 'POST' : 'GET', credentials: url === ENDPOINT ? 'omit' : 'same-origin',
        cache: 'no-store', redirect: 'error', headers: headers,
        body: data ? JSON.stringify(data) : undefined, signal: controller.signal});
      if (!response.ok) throw new Error('The estimate is unavailable. Please try again or contact us for a reviewed quote.' + RATE_NOTE);
      return await response.json();
    } catch (error) {
      if (error.name === 'AbortError') throw new Error('The estimate took too long. Please try again.');
      throw new Error('The estimate is unavailable. Please try again or contact us for a reviewed quote.' + RATE_NOTE);
    } finally { clearTimeout(timer); }
  }
  function updateReferences(reference, expected, owner) {
    var task = mutations.catch(function () {}).then(async function () {
      function checkOwner() {
        if (owner && (current !== owner || !owner.element.isConnected)) throw new Error('Your cart changed. Request a new estimate.');
      }
      checkOwner();
      var cart = await json(root + 'cart.js');
      checkOwner();
      if (expected && fingerprint(cart) !== expected) throw new Error('Your cart changed. Request a new estimate.');
      // Keys identify the intended item if another tab changes cart positions.
      // Property-only writes must never overwrite a customer's quantity edit.
      var keys = cart.items.filter(function (item) { return item.requires_shipping; }).map(function (item) { return item.key; });
      for (var index = 0; index < keys.length; index++) {
        checkOwner();
        var item = cart.items.find(function (entry) { return entry.key === keys[index]; });
        if (!item) throw new Error('Your cart changed. Request a new estimate.');
        if (!reference && !Object.prototype.hasOwnProperty.call(item.properties || {}, PROPERTY)) continue;
        var props = properties(item);
        if (reference) props[PROPERTY] = reference;
        // Shopify cannot replace an existing properties map with {}. A separate
        // harmless private marker lets us remove the exact quote key completely.
        else if (!Object.keys(props).length) props[CLEARED] = 'true';
        cart = await json(root + 'cart/change.js', {id: item.key, properties: props});
        if (expected && fingerprint(cart) !== expected) throw new Error('Your cart changed. Request a new estimate.');
      }
      if (!reference && cart.items.some(function (item) { return item.requires_shipping && Object.prototype.hasOwnProperty.call(item.properties || {}, PROPERTY); })) {
        throw new Error('Could not clear the previous estimate. Checkout can continue at the standard shipping rate.');
      }
      return cart;
    });
    mutations = task;
    return task;
  }
  function referencesMatch(cart, quote) {
    var items = cart.items.filter(function (item) { return item.requires_shipping; });
    return items.length > 0 && items.every(function (item) { return (item.properties || {})[PROPERTY] === quote.quote_id; });
  }
  function mount(element) {
    if (mounted.has(element)) return;
    mounted.add(element);
    if (current) current.invalidate();
    var form = element.querySelector('[data-canada-form]'), toggle = element.querySelector('[data-canada-active]');
    var panel = element.querySelector('[data-canada-panel]'), status = element.querySelector('[data-canada-status]');
    var result = element.querySelector('[data-canada-result]'), estimate = element.querySelector('[data-canada-estimate]');
    var proceed = element.querySelector('[data-canada-continue]');
    var state = {element: element, quote: null, revision: 0, busy: false}; current = state;
    function message(text, error) { status.textContent = text; status.dataset.error = String(!!error); }
    function invalidate(text) {
      state.quote = null; state.revision++; clearTimeout(state.timer); result.hidden = true; proceed.hidden = true;
      if (text) message(text, true);
    }
    state.invalidate = invalidate;
    state.message = message;
    function destination() {
      var data = new FormData(form);
      return {address1: data.get('address1').trim(), address2: data.get('address2').trim(),
        city: data.get('city').trim(), province: data.get('province'), postal_code: data.get('postal_code').trim().toUpperCase(), country: 'CA'};
    }
    function render(quote) {
      result.replaceChildren();
      function paragraph(text) { var p = document.createElement('p'); p.textContent = text; result.appendChild(p); }
      var list = document.createElement('dl'); result.appendChild(list);
      function row(label, value, total) {
        var div = document.createElement('div'), dt = document.createElement('dt'), dd = document.createElement('dd');
        dt.textContent = label; dd.textContent = quote.currency + ' ' + value; if (total) div.className = 'canada-import-quote__total';
        div.append(dt, dd); list.appendChild(div);
      }
      var c = quote.components, native = quote.tax_source === 'shopify_native';
      row('UPS Standard transportation estimate', c.transport);
      row('Shipping markup', c.transport_markup);
      if (!native) { row('Estimated duties', c.duties); row('Estimated import taxes and government fees', c.taxes_and_fees); }
      row('Estimated UPS brokerage / clearance', c.brokerage);
      row(native ? 'Estimated shipping and clearance charge' : 'Estimated shipping and import charge', c.total, true);
      if (native) {
        paragraph('Shopify calculates and collects duties and import taxes separately at checkout. They are not included in the shipping and clearance charge above.');
        paragraph('UPS comparison estimate: duties ' + quote.currency + ' ' + quote.import_components.duties + '; import taxes and government fees ' + quote.currency + ' ' + quote.import_components.taxes_and_fees + '. These are estimates, not an additional charge here.');
      } else paragraph('The shipping option includes the estimated duties, import taxes and UPS brokerage / clearance shown above.');
      paragraph('These are estimates in ' + quote.currency + ', not the final order total. Valid until ' + new Date(quote.expires_at).toLocaleTimeString() + '. Enter this same Canadian address at checkout and select UPS Standard — import costs prepaid.');
      result.hidden = false; proceed.hidden = false;
    }
    toggle.checked = active() || location.hash === '#canada-import-estimate';
    setActive(toggle.checked, toggle.checked || (!departureClear && !departureError)); panel.hidden = !toggle.checked;
    toggle.addEventListener('change', function () {
      departureGeneration++;
      // Keep domestic intent in memory until stale references are actually
      // cleared, so a failed cleanup followed by reload remains protected.
      setActive(toggle.checked, toggle.checked); panel.hidden = !toggle.checked; invalidate();
      departureError = null;
      var pending = updateReferences(null, null, state); departureClear = pending;
      pending.then(function () {
        if (departureClear === pending) {
          departureClear = null; departureError = null;
          if (current === state && element.isConnected && !toggle.checked && !active()) setActive(false);
        }
      }, function () {
        if (departureClear !== pending) return;
        departureClear = null;
        departureError = new Error('Could not clear the previous estimate. Checkout can continue at the standard shipping rate.');
        panel.hidden = false; message(departureError.message, true);
      });
    });
    form.addEventListener('input', function () {
      var hadQuote = !!state.quote || state.busy;
      invalidate(hadQuote ? 'Address changed. Request a new estimate.' : '');
      if (hadQuote) updateReferences(null, null, state).catch(function () { message('Refresh your cart before requesting a new estimate.', true); });
    });
    form.addEventListener('submit', async function (event) {
      event.preventDefault(); if (state.busy || !form.reportValidity()) return;
      // Requesting a Canadian estimate renews that intent even if the panel
      // stayed open after a failed attempt to leave the Canadian flow.
      toggle.checked = true; setActive(true); panel.hidden = false;
      invalidate(); var revision = state.revision, cleanupGeneration = departureGeneration;
      state.busy = true; estimate.disabled = true;
      message('Getting your shipping and import estimate…');
      try {
        var cart = await updateReferences(null, null, state);
        if (current !== state || state.revision !== revision || !element.isConnected) throw new Error('Your cart or address changed. Request a new estimate.');
        // Successful retry cleanup recovers an old failure only while it is
        // still authoritative. A newer departure owns its own pending/error state.
        if (departureGeneration === cleanupGeneration && !departureClear) departureError = null;
        var facts = fingerprint(cart), address = destination();
        if (!cart.items.some(function (item) { return item.requires_shipping; })) throw new Error('Add a shippable item before requesting an estimate.');
        var path = tokenPath(element.getAttribute('data-canada-token-path'));
        // Fetch a fresh short-lived token for this attempt. It is never stored
        // in the cart, browser storage, logs, or customer-visible markup.
        var token = quoteToken(await json(path));
        if (state.revision !== revision || !element.isConnected) throw new Error('Your cart or address changed. Request a new estimate.');
        var quote = validateQuote(await json(ENDPOINT, {rate: {destination: address, currency: cart.currency, items: cartFacts(cart)}}, token), Date.now(), cart.currency);
        if (state.revision !== revision || !element.isConnected) throw new Error('Your cart or address changed. Request a new estimate.');
        cart = await updateReferences(quote.quote_id, facts, state);
        if (state.revision !== revision || !element.isConnected || !referencesMatch(cart, quote)) throw new Error('Your cart or address changed. Request a new estimate.');
        validateQuote(quote, Date.now(), cart.currency);
        state.quote = quote; state.facts = facts; state.address = JSON.stringify(address);
        departureError = null;
        departureClear = null;
        toggle.checked = true;
        setActive(true);
        state.timer = setTimeout(function () {
          if (current !== state || !element.isConnected) return;
          invalidate('Your estimate expired. Checkout can continue at the standard shipping rate, or you can request a new estimate.');
          var settle = clearStaleActive();
          updateReferences(null, null, state).catch(function () {}).then(function () { if (current === state) settle(); });
        }, Date.parse(quote.expires_at) - Date.now());
        render(quote); message('Your estimate is ready. Continue to checkout with the same delivery address.');
      } catch (error) {
        invalidate(error.message || 'The estimate is unavailable. Please try again.');
        var settle = clearStaleActive();
        if (current === state && element.isConnected) await updateReferences(null, null, state).catch(function () {});
        if (current === state) settle();
      } finally { state.busy = false; estimate.disabled = false; }
    });
    state.check = async function () {
      if (state.busy || !state.quote || !element.isConnected) throw new Error('Get a current Canadian estimate before checkout.');
      validateQuote(state.quote, Date.now());
      var quote = state.quote, revision = state.revision;
      var cart = await json(root + 'cart.js');
      if (current !== state || !element.isConnected || state.quote !== quote || state.revision !== revision) throw new Error('Your cart changed. Request a new estimate.');
      if (fingerprint(cart) !== state.facts || JSON.stringify(destination()) !== state.address || !referencesMatch(cart, state.quote)) {
        invalidate(); await updateReferences(null, null, state); throw new Error('Your cart or address changed. Request a new estimate.');
      }
      validateQuote(state.quote, Date.now(), cart.currency);
    };
    proceed.addEventListener('click', function () { var button = document.querySelector('.cart-page button[name="checkout"]'); if (button) button.click(); });
  }
  function discover() { document.querySelectorAll('[data-canada-import-quote]').forEach(mount); }
  window.addEventListener('hashchange', function () {
    if (location.hash !== '#canada-import-estimate' || !current || !current.element.isConnected) return;
    var toggle = current.element.querySelector('[data-canada-active]');
    if (!toggle.checked) { toggle.checked = true; toggle.dispatchEvent(new Event('change')); }
    current.element.querySelector('[name=address1]').focus();
  });
  function cartUrl() { return root + 'cart' + (active() ? '#canada-import-estimate' : ''); }
  function requireCart(message) {
    if (current && current.element.isConnected) {
      current.element.querySelector('[data-canada-panel]').hidden = false;
      current.message(message || 'Get a current Canadian estimate before checkout.', true);
      current.element.scrollIntoView({block: 'nearest'});
    } else if (location.pathname === new URL(root + 'cart', location.href).pathname) location.reload();
    else location.assign(cartUrl());
  }
  var accelerated = '[data-dynamic-checkout], .shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, [data-shopify-buttoncontainer], .cart-page__dynamic-checkout';
  // Shopify wallets use a closed shadow DOM. They are omitted in Liquid when
  // enabled; this also catches stale or dynamically inserted outer controls.
  window.addEventListener('click', function (event) {
    syncMarket();
    if (!canadaShopper()) return;
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest(accelerated)) {
      event.preventDefault(); event.stopImmediatePropagation(); requireCart(); return;
    }
    var link = target.closest('a[href]');
    if (!link) return;
    var url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;
    if (/\/checkout\/?$/.test(url.pathname)) {
      event.preventDefault(); event.stopImmediatePropagation();
      var checkout = document.querySelector('.cart-page button[name="checkout"]');
      if (checkout) checkout.click(); else location.assign(cartUrl());
    } else if (/\/cart\/[^/]+:\d/.test(url.pathname) && url.searchParams.get('storefront') !== 'true') {
      event.preventDefault(); event.stopImmediatePropagation();
      url.searchParams.set('storefront', 'true'); location.assign(url.href);
    }
  }, true);
  document.addEventListener('submit', async function (event) {
    syncMarket();
    if (!canadaShopper()) return;
    var button = event.submitter, form = event.target;
    if (bypass.has(form)) { bypass.delete(form); return; }
    if (!(form instanceof HTMLFormElement)) return;
    var action = new URL(button && button.hasAttribute('formaction') ? button.formAction : form.action, location.href);
    var checkout = (button && button.name === 'checkout') || /\/checkout\/?$/.test(action.pathname) ||
      (!button && /\/cart\/?$/.test(action.pathname) && form.querySelector('[name="checkout"]'));
    if (!checkout) return;
    // Every enabled drawer/product entry first visits the guarded cart, even
    // before the customer has selected a destination.
    if (!form.closest('.cart-page')) {
      event.preventDefault(); event.stopImmediatePropagation(); location.assign(cartUrl()); return;
    }
    if (!canadaEngaged()) return;
    // A valid quote stays on the lines. A failed, missing, expired, or
    // unreachable quote is cleared and checkout continues at the legacy rate.
    event.preventDefault(); event.stopImmediatePropagation();
    if (button) button.disabled = true;
    var keep = false;
    try {
      if (departureClear) await departureClear;
      if (!departureError && active() && current && current.quote && !current.busy && current.element.isConnected) {
        await current.check();
        keep = true;
      }
    } catch (_) { keep = false; }
    if (!keep) { try { await releaseQuote(); } catch (_) { /* Continue either way. */ } }
    try { continueCheckout(form, button); }
    finally { if (button) button.disabled = false; }
  }, true);
  document.addEventListener('cart:updated', async function () {
    var owner = current;
    if (owner && owner.quote) {
      try { await owner.check(); return; }
      catch (_) { if (current !== owner || !owner.element.isConnected) return; }
    }
    var settle = clearStaleActive();
    if (owner && current === owner) owner.invalidate('Your cart changed. Request a new estimate.');
    updateReferences(null, null, owner).catch(function () {}).then(function () {
      if (!current || !current.quote) settle();
    });
  });
  new MutationObserver(discover).observe(document.body, {childList: true, subtree: true});
  new MutationObserver(syncMarket).observe(document.body, {attributes: true, attributeFilter: ['data-canada-market']});
  syncMarket();
  discover();
})();
